import { render, staticRenderFns } from "./Covid19Update.vue?vue&type=template&id=1306783a"
import script from "./Covid19Update.vue?vue&type=script&lang=js"
export * from "./Covid19Update.vue?vue&type=script&lang=js"
import style0 from "./Covid19Update.vue?vue&type=style&index=0&id=1306783a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports